import { Div, Label } from "@grassrootly/rn-core";
import { ScrollView } from "react-native";
import GamePlayers from "../../components/game/game-attendees/GamePlayers";
import { GameVotingSectionProps } from "./GameVote.types";

export default function GameSectionVote({ attendees, onSelected, selectedId, title, hostTeamName, hostTeamLogo, visitorTeamName, visitorTeamLogo }: GameVotingSectionProps) {
  return (
    <Div classNames={["flex1"]}>
      <Label type="l1Bold" classNames={["colorPrimaryMain", "mb-{16}", "textCenter"]}>
        {title}
      </Label>
      <ScrollView style={{ flex: 1 }}>
        <GamePlayers 
          attendees={attendees} 
          onSelected={onSelected} 
          selectedId={selectedId}
          hostTeamName={hostTeamName}
          hostTeamLogo={hostTeamLogo}
          visitorTeamName={visitorTeamName}
          visitorTeamLogo={visitorTeamLogo}
        />
      </ScrollView>
    </Div>
  );
}
